// extracted by mini-css-extract-plugin
export default {"header":"ZK","light":"aL","dark":"bL","headertitle":"cL","fname":"eL","headerContent":"fL","right":"gL","descriptionwrapper":"hL","appear":"iL","second":"jL","third":"kL","forth":"lL"};
    if(module.hot) {
      // 1743628929419
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  